import type { Reference } from '@sydle/sydle-one-components';
import type { FetchResponse } from '@sydle/ui-api';
import { portalCustomAPI } from '.';

export interface AttendTaskInput {
  task: Reference;
}

export interface AttendTaskOutput {
  draft?: {
    _id: string;
    _classId: string;
    taskName: string;
  };
  task?: any;
}

export async function attendTask(input: AttendTaskInput): Promise<FetchResponse<AttendTaskOutput>> {
  return await portalCustomAPI.fetch<AttendTaskInput, AttendTaskOutput>('attendTask', input);
}
